export default {
  discount_badge: '{{value}} off',
};
